import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../css/AdminServiceCompanyDashboard.css';

function AdminServiceCompanyDashboard() {
    const navigate = useNavigate();
    const [selectedStatus, setSelectedStatus] = useState('');
    const [statuses, setStatuses] = useState([]);
    const [serviceCompanies, setServiceCompanies] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        const fetchStatuses = async () => {
            try {
                const response = await axios.get('/api/admin/service_company_statuses');
                if (Array.isArray(response.data.statuses)) {
                    setStatuses([...response.data.statuses, { name: "Search", count: 0 }]);
                    if (response.data.statuses.length > 0) {
                        setSelectedStatus(response.data.statuses[0].name);
                    }
                } else {
                    console.error('Expected an array but got:', response.data.statuses);
                }
            } catch (error) {
                console.error('Error fetching statuses:', error);
            }
        };

        fetchStatuses();
    }, []);

    useEffect(() => {
        const fetchCompanies = async () => {
            if (selectedStatus) {
                try {
                    if (selectedStatus === "Search") {
                        await handleSearch({ preventDefault: () => {} });
                        return;
                    }
                    const response = await axios.get(
                        `/api/admin/service_companies?status=${encodeURIComponent(selectedStatus)}`
                    );
                    if (Array.isArray(response.data)) {
                        setServiceCompanies(response.data);
                    } else {
                        console.error('Expected an array but got:', response.data);
                    }
                } catch (error) {
                    console.error('Error fetching companies:', error);
                }
            }
        };

        fetchCompanies();
    }, [selectedStatus]);

    const handleSearch = async (e) => {
        e.preventDefault();

        setSelectedStatus("Search");

        if (!search.trim()) {
            updateSearchCount(0);
            return;
        }

        try {
            const response = await axios.get(`/api/admin/service_companies_search?search=${encodeURIComponent(search)}`);

            if (Array.isArray(response.data)) {
                setServiceCompanies(response.data);
                updateSearchCount(response.data.length);
            } else {
                console.error("Expected an array but got:", response.data);
            }
        } catch (error) {
            console.error("Error during search request:", error);
        }
    };

    const updateSearchCount = (count) => {
        setStatuses((prevStatuses) =>
            prevStatuses.map((status) =>
                status.name === "Search"
                    ? { ...status, count: count }
                    : status
            )
        );
    }

    return (
        <div className="adminServiceCompanyDashboardContainer">
            <div className="adminServiceCompanyDashboardHeaderContainer">
                <div className="adminServiceCompanyDashboardTitle">Service Companies</div>
                <div className="adminServiceCompanyDashboardSearchBar">
                    <form className="adminServiceCompanyDashboardSearchForm" onSubmit={handleSearch}>
                        <input
                            type="text"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <button type="submit">Search</button>
                    </form>
                    <div className="adminServiceCompanyDashboardNewButton"><button onClick={() => navigate(`/admin/service-company/new`)}>Add New</button></div>
                </div>
                <div className="adminServiceCompanyDashboardFilters">
                    {statuses.map((status) => (
                        <div key={status.id} className={`adminServiceCompanyDashboardFilter ${selectedStatus === status.name ? 'selected' : ''}`}
                             onClick={() => setSelectedStatus(status.name)}>
                            {status.name} ({status.count})
                        </div>
                    ))}
                </div>
            </div>
            <div className="adminServiceCompanyDashboardBodyContainer">
                <table className="adminServiceCompanyTable">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Contact Name</th>
                        <th>Primary Service City</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Primary Trade</th>
                        <th>Company Website</th>
                        <th>Company City</th>
                        <th>Create Date</th>
                        <th>Updated Date</th>
                        <th>Edited by</th>
                    </tr>
                    </thead>
                    <tbody>
                    {serviceCompanies.map((company) => (
                        <tr key={company.id} onClick={() => navigate(`/admin/service-company/${company.id}`)}>
                            <td>{company.id}</td>
                            <td>{company.name}</td>
                            <td>{company.contact_name}</td>
                            <td>{company.cities?.[0]?.name || "None"}</td>
                            <td>{company.email}</td>
                            <td>{company.phone}</td>
                            <td>{company.trades?.[0]?.name || "None"}</td>
                            <td>{company.homepage_url}</td>
                            <td>{company.city}</td>
                            <td>{new Date(company.created_at).toLocaleString()}</td>
                            <td>{new Date(company.updated_at).toLocaleString()}</td>
                            <td>{company.edited_by?.email}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AdminServiceCompanyDashboard;
